import { useEffect } from "react";
import { useNavigate } from "react-router";
import { TopNavigation } from "@hamlak/ui";
import logoUrl from "@hamlak/ui/brand/logo.svg";
import { t } from "@/i18n/ko";
import { useUiStore } from "@/stores/uiStore";
import { BottomTabs } from "@/components/BottomTabs";
import { EmptyState } from "@/components/EmptyState";
import { HomeFooter } from "./HomeFooter";
import { PlotGrid, PlotGridSkeleton } from "./PlotGrid";
import { usePlots } from "./usePlots";
import { useIsBackdrop } from "@/app/layout/backdrop";

/** PC 로그인·가입 모달 뒤에 깔릴 때(backdrop)는 화면 진입이 아니므로 home_view·오류 스낵바를 내지 않는다. */
export function HomePage() {
  const backdrop = useIsBackdrop();
  const navigate = useNavigate();
  const showSnackbar = useUiStore((s) => s.showSnackbar);
  const plots = usePlots();
  const items = plots.data?.pages.flatMap((p) => p.items) ?? [];

  // 캐시가 있는데 재조회·다음 페이지가 실패하면(오프라인 등) 목록은 두고 Snackbar + 재시도(1.1 엣지).
  const { isError, error, refetch, fetchNextPage, isFetchNextPageError } = plots;

  useEffect(() => {
    if (backdrop || !isError || items.length === 0) return;
    showSnackbar(t("home.loadError"), { label: t("common.retry"), onClick: () => void (isFetchNextPageError ? fetchNextPage() : refetch()) });
    // error 객체가 바뀔 때마다 1회
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, error]);

  return (
    <main className="page page--wide">
      {/* 시안(Ultra 펼침 홈 402:2363): 로고형 헤더, 제목·브릭 pill 없음. 잔액은 채팅방·상점·마이페이지에서 보여 준다. PC(large)는 GNB 가 대신해 숨김 */}
      <TopNavigation className="home__nav" type="logo" logo={<img src={logoUrl} alt={t("app.name")} height={27} />} left={null} right={null} />
      {plots.isPending ? (
        <PlotGridSkeleton />
      ) : plots.isError && items.length === 0 ? (
        <EmptyState message={t("home.loadError")} action={{ label: t("common.retry"), onClick: () => void plots.refetch() }} />
      ) : items.length === 0 ? (
        <EmptyState message={t("home.empty")} />
      ) : (
        <PlotGrid
          items={items}
          onSelect={(plot) => {
            navigate(`/plots/${encodeURIComponent(plot.slug)}`);
          }}
          hasNext={plots.hasNextPage}
          isFetchingNext={plots.isFetchingNextPage}
          fetchNext={() => void plots.fetchNextPage()}
        />
      )}
      <HomeFooter />
      <BottomTabs current="home" />
    </main>
  );
}
